<template>

    <b-modal v-model="openedModal" centered :title="`${(type === 'add' ? 'Dodaj' : 'Uredi')} podkategorijo`" hide-footer>
        <b-overlay :show="showLoader" >
            <b-row>
                <b-col>
                    <validation-observer ref="validate">
                        <b-form>
                            <validation-provider #default="{ errors }" name="naslov kategorije" rules="required|max:30">
                                <b-form-group>
                                    <label>Naslov:</label>
                                    <b-form-input v-model="category.title" placeholder="NASLOV"/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="{ errors }" name="bbis id" rules="required|max:30">
                                <b-form-group>
                                    <label>BBIS ID:</label>
                                    <b-form-input v-model="category.bbis_id" placeholder="BBIS ID"/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-form>
                    </validation-observer>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col class="text-center">
                    <ImageSelector ref="childrenCategoryImageSelector" :main_photo="category.main_photo" 
                                   :additional_photos="category.additional_photos" 
                                   @update-main-photo="updateMainPhoto" 
                                   :type="type"
                                   :additional_photos_enabled="false" />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="secondary" @click="validateForm">{{ (type === 'add' ? 'DODAJ' : 'UREDI') }}</b-button>
                </b-col>
            </b-row>
        </b-overlay>
    </b-modal>

</template>

<script>
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required, max } from '@validations'
    import ImageSelector from '@/views/Components/ImageSelector'
    import {BButton, BCol, BForm, BFormGroup, BFormInput, BModal, BOverlay, BRow} from 'bootstrap-vue'
    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            ImageSelector,
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BRow,
            BCol,
            BOverlay
        },
        props: {
            type: {
                type: String,
                reqired: true
            },
            category: {
                type: Object,
                reqired: true
            },
            parentId: {
                type: String,
                reqired: false
            }
        },
        data() {
            return {
                openedModal: false,
                required, 
                max,
                showLoader: false
            }
        },
        methods: {
            openModal() {
                this.openedModal = true
            },
            async validateForm() {
                const res = await this.$refs.validate.validate()
                if (res) {
                    if (this.type === 'add') await this.addCategory()
                    else if (this.type === 'edit') await this.editCategory()
                }
                
            },
            async addCategory() {
                const thisIns = this
                thisIns.showLoader = true
                const isImageUploadSuccessfull = await this.$refs.childrenCategoryImageSelector.UploadImagesToAPI()
                if (!isImageUploadSuccessfull) {
                    this.$printError('Prišlo je do napake pri nalaganju slik.')
                    thisIns.showLoader = false
                    return
                }
                if (this.category.main_photo === '') {
                    this.$printWarning('Potrebno je dodati vsaj eno fotografijo')
                    this.showLoader = false
                    return
                }
                
                // if it happens, that photo is pushed to additional_photos, just empty array,
                // because only main_photo must be populated
                this.category.additional_photos = []

                const loadPromise = this.$http.put(`/api/management/v1/shop/category/${this.parentId}`, this.category)
                loadPromise.then(function() {
                    thisIns.$printSuccess('Podkategorija je dodana')
                    thisIns.category.title = ''
                    thisIns.openedModal = false
                    thisIns.$emit('success')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(() => {
                    thisIns.showLoader = false
                })
            },
            async editCategory() {
                const thisIns = this
                this.showLoader = true
                const isImageUploadSuccessfull = await this.$refs.childrenCategoryImageSelector.UploadImagesToAPI()
                if (!isImageUploadSuccessfull) {
                    thisIns.$printError('Prišlo je do napake pri nalaganju slik.')
                    thisIns.showLoader = false
                    return
                }
                if (thisIns.category.main_photo === '') {
                    thisIns.$printWarning('Potrebno je dodati vsaj eno fotografijo')
                    thisIns.showLoader = false
                    return
                }

                // if it happens, that photo is pushed to additional_photos, just empty array,
                // because only main_photo must be populated
                this.category.additional_photos = []

                const loadPromise = this.$http.patch(`/api/management/v1/shop/category/${this.category.id}`, this.category)
                loadPromise.then(function() {
                    thisIns.$printSuccess('Podkategorija je urejena')
                    thisIns.category.title = ''
                    thisIns.openedModal = false
                    thisIns.$emit('success')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(() => {
                    thisIns.showLoader = false
                })
            },
            updateMainPhoto(main_photo_id) {
                this.category.main_photo = main_photo_id
            }
        }
    }
</script>

<style scoped>

</style>